// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"3ecb178d","397":"f57156c9"}[chunkId] + ".chunk.js";
};